import useEmblaCarousel from 'embla-carousel-react';
import type { ReactNode } from 'react';
import { styled } from 'styled-components';
import { DotButton, useDotButton } from './CarouselDotButton'

import { space } from '@sunwebgroup/ui-components';

interface CarouselProps {
  children: ReactNode;
}

export function Carousel({ children }: CarouselProps) {
  const [emblaRef, emblaApi] = useEmblaCarousel({
    dragFree: true,
  })

  const { selectedIndex, scrollSnaps, onDotButtonClick } =
    useDotButton(emblaApi)
  return <Slider>
    <ViewPort ref={emblaRef}>
      <Wrapper>
        {children}
      </Wrapper>
    </ViewPort>
    <CarouselControls>
      <CarouselDots>
        {scrollSnaps.map((_, index) => {
          return <DotButton
            key={index}
            onClick={() => onDotButtonClick(index)}
            $selected={index === selectedIndex}
          />
        })}
      </CarouselDots>
    </CarouselControls>
  </Slider>
}

const Slider = styled.section ``
const ViewPort = styled.div `
  overflow: hidden;`
const Wrapper = styled.div `
  display: flex;
  touch-action: pan-y pinch-zoom;
  margin-left: ${space('primitives_space_16')};
`
export const Slide = styled.div `
  transform: translate3d(0, 0, 0);
  flex: 0 0 90%;
  min-width: 0;
  padding-right: 1rem;
`
const CarouselControls = styled.div `
  margin-top: ${space('primitives_space_12')};
`
const CarouselDots = styled.div `
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  gap: ${space('primitives_space_8')};
`
